wp.blocks.registerBlockType("creditablepaywall/paywall", {
    title: "Creditable Paywall",
    icon: "money-alt",
    category: "common",
    keywords: [
        "pay-per-article",
        "pay per article",
        "paywall"
    ],
    supports: {
        inserter: true,
        multiple: false
    },
    minTitleLength: 1,
    edit: function (props) {
        return (
            <div id="creditablepaywall">
                <span>pay-per-article content below</span>
            </div>

        )
    },
    save: function (props) {
        return null;
    }
});


